import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames/bind';
import { Button } from '@miroculus/nucleo';
import { DASHBOARD_URL } from 'cons/routes';
import { Header } from 'containers';
import styles from './PageNotFoundError.scss';
const cx = classnames.bind(styles);
const PageNotFoundError = memo(({ title = 'Page not found', code = '404', message = 'The page you were trying to access does not exist, please check your URL or return to the home page.', buttonLabel = 'Home page', showButton = true, onButtonClick, }) => {
    const navigate = useNavigate();
    const buttonClickHandler = useCallback(() => onButtonClick ? onButtonClick() : navigate(DASHBOARD_URL), [onButtonClick, navigate]);
    return (React.createElement("div", { className: cx('container') },
        React.createElement(Header, null),
        React.createElement("div", { className: cx('body') },
            React.createElement("h1", { className: cx('code') }, code),
            React.createElement("h2", { className: cx('title') }, title),
            React.createElement("div", { className: cx('messageContainer') },
                React.createElement("h3", { className: cx('message') }, message),
                showButton ? (React.createElement("div", { className: cx('buttonContainer') },
                    React.createElement(Button, { onClick: buttonClickHandler, size: "small", flavor: "secondary" }, buttonLabel))) : null))));
});
export default PageNotFoundError;
